import React from "react";
import { Link, useParams } from "react-router-dom";

const BreadcrumbTwo = ({ product }) => {
  const { category } = useParams();

  // Convert "apple-accessories" → "Apple Accessories"
  const formattedCategory = category
    ? category.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
    : "Shop";

  return (
    <div className="breadcrumb py-26 bg-color-one">
      <div className="container container-lg">
        <div className="breadcrumb-wrapper flex-between flex-wrap gap-16">
          <h6 className="mb-0">{product?.title || "Shop Details"}</h6>

          <ul className="flex-align gap-8 flex-wrap">
            {/* HOME */}
            <li className="text-sm">
              <Link to="/" className="text-main-600 flex-align gap-8">
                <i className="ph ph-house" />
                Home
              </Link>
            </li>

            <li className="flex-align text-gray-500">
              <i className="ph ph-caret-right" />
            </li>

            {/* SHOP */}
            <li className="text-sm">
              <Link to="/shop" className="text-main-600 flex-align gap-8">
                Shop
              </Link>
            </li>

            <li className="flex-align text-gray-500">
              <i className="ph ph-caret-right" />
            </li>

            {/* CATEGORY */}
            <li className="text-sm">
              <Link
                to={`/shop/${category}`}
                className="text-main-600 flex-align gap-8"
              >
                {formattedCategory}
              </Link>
            </li>

            <li className="flex-align text-gray-500">
              <i className="ph ph-caret-right" />
            </li>

            {/* PRODUCT NAME */}
            <li className="text-sm text-neutral-600">
              {product?.title || "Product"}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default BreadcrumbTwo;
